export default "__VITE_ASSET__CZdmKw7f__"